import { Select } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import styles from './CompanyInputManualDE.module.css';
import { DE_COMPANY_TYPE } from './companyLegalForms';
import { useIsInDECompanySearchUITest } from '../../../../../hooks/useIsInDECompanySearchUITest';
import { TCompanyDetailsDataDE } from '../../CompanyDetailsDE';

const CompanyLegalFormDE = () => {
  const { t } = useLingui();

  const { isIncludedInCompanySearchUITest } = useIsInDECompanySearchUITest();

  const {
    register,
    formState: { errors },
  } = useFormContext<TCompanyDetailsDataDE>();

  return (
    <div className={styles.formFieldGroup}>
      <Select
        {...register('legalForm')}
        label={
          isIncludedInCompanySearchUITest
            ? t`What legal form does your business have?`
            : t`What legal form does your company have?`
        }
        placeholder={t`Please select`}
        error={errors?.legalForm?.message}
        className={clsx(
          {
            [styles.erroredSelect]: errors.legalForm?.message,
          },
          'fs-mask',
        )}
      >
        {DE_COMPANY_TYPE.map((companyType) => (
          <option
            key={companyType.value}
            value={companyType.value}
            className="fs-mask dd-privacy-mask"
          >
            {companyType.label}
          </option>
        ))}
      </Select>
    </div>
  );
};

export default CompanyLegalFormDE;
